import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BellIcon } from '@radix-ui/react-icons';
import { getUnreadNotificationCount } from '../api/notification';
import { Button } from './common/Button';
import { cn } from '../utils/cn';

const NotificationBell = () => {
  const [unreadCount, setUnreadCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUnreadCount = async () => {
      try {
        const count = await getUnreadNotificationCount();
        setUnreadCount(count);
      } catch (error) {
        console.error('Failed to fetch unread notifications count:', error);
      }
    };

    // Fetch initial count
    fetchUnreadCount();

    // Set up polling every minute
    const interval = setInterval(fetchUnreadCount, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => navigate('/notifications')}
      className="relative"
      aria-label="View notifications"
    >
      <BellIcon className="h-5 w-5" />
      {unreadCount > 0 && (
        <span className={cn(
          "absolute top-1 right-1 -mt-1 -mr-1",
          "flex items-center justify-center h-4 w-4",
          "text-[10px] font-bold text-white",
          "bg-red-500 rounded-full"
        )}>
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </Button>
  );
};

export default NotificationBell; 